// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__Vm6qF","card--kube":"styles_card--kube__MDBcd","skeleton-animation":"styles_skeleton-animation__OcQxA"};